
//////////////////////////////////////////////////////  GLOBAL VARIABLES ////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////

function grabHtmlContentForLangSelector() {

langSelector = document.querySelector('.languages');

return {
	langSelector,
	langSelectorLangInpOptions_a: langSelector?.querySelectorAll('input[type="radio"]'),
	langSelectorLabelForLangInpOptions_a: langSelector?.querySelectorAll('label'),
}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////// DISPLAY THE SELECTED LANGUAGE OVER THE LANGUAGE SELECTOR ICON //////////////////////////////

function langSelectorDisplayUpdate(selectedLang, langSelectorLangInpOptions_a, langSelectorLabelForLangInpOptions_a) {
	
	langSelectorLangInpOptions_a.forEach( (langOption) => {
		
		if (langOption.value === selectedLang)
			{
				langOption.checked = true;
			}
		else
			{
				langOption.checked = false;
			}
	})
	
	langSelectorLabelForLangInpOptions_a.forEach((langLabel) => {
		
		if (langLabel.getAttribute("for") === selectedLang)
			{
				langLabel.style.outline = "0.1vmin solid black;\n outline-offset: -0.1vmin";
				langLabel.style.boxShadow = "inset 0vmin 0vmin 0.5vmin 0vmin";
//				langLabel.style.borderImage = "linear-gradient(to left, rgba(0,0,0,0.8), transparent 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0";
//				langLabel.style.borderImage = "linear-gradient(to left, rgba(0,0,0,0.8), rgba(211,211,211,0.5) 10% 90%, rgba(0,0,0,0.8)) 0 fill/0/0";
				langLabel.style.borderImage = "linear-gradient(to left, rgba(211,211,211,0.2) 0% 100%) 0 fill/0/0;}\n`";
			}
		else
			{
				langLabel.style.outline = "none";
				langLabel.style.boxShadow = "none";
				langLabel.style.borderImage = "none";
			}
	})
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////	EVENT HANDLERS /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////// HANDLER FOR LANGUAGE SELECTOR BUTTON PRESSED EVENT /////////////////////////////

document.addEventListener('DOMContentLoaded', () => {
	
	const {langSelector, langSelectorLangInpOptions_a, langSelectorLabelForLangInpOptions_a} = grabHtmlContentForLangSelector();
	
	if (!langSelector || !langSelectorLangInpOptions_a || !langSelectorLabelForLangInpOptions_a) return;
	
//START OF "On page load, store all the available languages in the site"
	var availableLang_a = [];
	
	langSelectorLabelForLangInpOptions_a.forEach((langLabel) => {
			
			availableLang_a.push(langLabel.getAttribute("for"));
	})
	
	localStorage.setItem("availableLang", JSON.stringify(availableLang_a));

//END OF "On page load, store all the available languages in the site"

//START OF "On page load, restore the selected language"
	
	var selectedLang = localStorage.getItem("langSelected");
	
	if (!selectedLang)
	{
		selectedLang = 'italian';
	}

	langSelectorDisplayUpdate(selectedLang, langSelectorLangInpOptions_a, langSelectorLabelForLangInpOptions_a);
	
	SiteApp.eventBus.emit("language:change", selectedLang);
	
//END OF "On page load, restore the selected language"
	
//START OF "Listens for user change of selected language"

	langSelector.addEventListener('change', (ev) => {
		
		var selectedLang = ev.target.value;
		
		langSelectorDisplayUpdate(selectedLang, langSelectorLangInpOptions_a, langSelectorLabelForLangInpOptions_a);

		localStorage.setItem("langSelected", selectedLang);
		
		SiteApp.eventBus.emit("language:change", selectedLang);
		
		})
//END OF "Listens for user change of selected language"

})

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////